'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var Radio = function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio() {
    var _temp, _this, _ret;

    _classCallCheck(this, Radio);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function (e) {
      _this.props.onChange(e.target.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Radio.prototype.render = function render() {
    var className = 'cf-radio';

    if (this.props.checked) {
      className += ' cf-radio--checked';
    }

    return React.createElement(
      'label',
      { htmlFor: this.props.name, className: className },
      React.createElement('input', { type: 'radio',
        className: 'cf-radio__input',
        id: this.props.name,
        name: this.props.name,
        value: this.props.value,
        checked: this.props.checked,
        onChange: this.handleChange }),
      this.props.label && React.createElement(
        'span',
        { className: 'cf-radio__label' },
        this.props.label
      )
    );
  };

  return Radio;
}(React.Component);

Radio.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};


module.exports = Radio;